import SourceScraper from './models/SourceScraper'
import { testScraper, storeSecondaryScraper } from '@/api/super'

export default {
  
  namespaced: true,

  state: {
    scraper: new SourceScraper()
  },

  mutations: {
    ...SourceScraper.mutations()
  },

  actions: {
    testScraper: ({state}, payload) => new Promise((resolve, reject) => {
      testScraper({
        ...payload,
        ...state.scraper
      }, ({data}) => {
        resolve(data)
      }, reject)
    }),
  },

  getters: {
    sourceScraper: state => state.scraper
  }

}